import React, { useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import { useHistory } from "react-router-dom";
import { Tag, Tooltip } from "antd";
import { toast } from "react-toastify";
import loader from "../../methods/loader";
import Pagination from "react-pagination-js";
import { useSelector } from "react-redux";
import Layout2 from "../../components/global/layout2";

var severityOptions = [
  { value: "", label: "All Severities" },
  { value: "critical", label: "Critical" },
  { value: "high", label: "High" },
  { value: "medium", label: "Medium" },
  { value: "low", label: "Low" },
];

var typeOptions = [
  { value: "", label: "All Types" },
  { value: "safety_score", label: "Safety Score" },
  { value: "insurance", label: "Insurance" },
  { value: "authority", label: "Authority" },
  { value: "fraud", label: "Fraud" },
  { value: "oos", label: "OOS" },
  { value: "asset_mismatch", label: "Asset Mismatch" },
];

var statusOptions = [
  { value: "", label: "All Statuses" },
  { value: "new", label: "New" },
  { value: "acknowledged", label: "Acknowledged" },
  { value: "resolved", label: "Resolved" },
];

var CarrierAlerts = function () {
  var historyHook = useHistory();
  var user = useSelector(function (state) { return state.user; });

  var initData = [];
  var initStats = { critical: 0, high: 0, medium: 0, resolved_today: 0 };

  var dataState = useState(initData);
  var data = dataState[0];
  var setData = dataState[1];

  var totalState = useState(0);
  var total = totalState[0];
  var setTotal = totalState[1];

  var loaderState = useState(false);
  var loaderr = loaderState[0];
  var setLoaderr = loaderState[1];

  var statsState = useState(initStats);
  var stats = statsState[0];
  var setStats = statsState[1];

  var expandedState = useState({});
  var expanded = expandedState[0];
  var setExpanded = expandedState[1];

  var filtersState = useState({
    page: 1,
    count: 20,
    severity: "",
    type: "",
    status: "",
  });
  var filters = filtersState[0];
  var setFilter = filtersState[1];

  var ChangeFilter = function (e) {
    setFilter(e);
    getData(e);
  };

  var pageChange = function (e) {
    setFilter({ ...filters, page: e });
    getData({ page: e });
  };

  var getStats = function () {
    ApiClient.get("admin/carrier-alerts/stats").then(function (res) {
      if (res.success && res.data) {
        setStats({
          critical: res.data.critical || 0,
          high: res.data.high || 0,
          medium: res.data.medium || 0,
          resolved_today: res.data.resolved_today || 0,
        });
      }
    });
  };

  var getData = function (p) {
    if (!p) p = {};
    loader(true);
    setLoaderr(true);
    var filter = { ...filters, ...p };
    var params = {};
    Object.keys(filter).forEach(function (key) {
      if (filter[key] !== "" && filter[key] !== undefined) {
        params[key] = filter[key];
      }
    });
    ApiClient.get("admin/carrier-alerts", params).then(function (res) {
      if (res.success) {
        setData(res?.data?.data || res?.data || []);
        setTotal(res?.data?.total_count || res?.data?.total || 0);
      }
      loader(false);
      setLoaderr(false);
    });
  };

  useEffect(function () {
    getData();
    getStats();
  }, []);

  var handleAction = function (alertId, action) {
    loader(true);
    ApiClient.put("admin/carrier-alert/" + alertId + "/" + action, {}).then(function (res) {
      if (res.success) {
        toast.success("Alert " + action + "d");
        getData();
        getStats();
      }
      loader(false);
    });
  };

  var toggleExpand = function (id) {
    var newExpanded = { ...expanded };
    newExpanded[id] = !newExpanded[id];
    setExpanded(newExpanded);
  };

  var formatDate = function (dateStr) {
    if (!dateStr) return "-";
    var d = new Date(dateStr);
    return d.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  var getSeverityTag = function (severity) {
    var colors = {
      critical: "red",
      high: "orange",
      medium: "gold",
      low: "blue",
    };
    return (
      <Tag color={colors[severity] || "default"} style={{ textTransform: "capitalize" }}>
        {severity || "Unknown"}
      </Tag>
    );
  };

  var getTypeIcon = function (type) {
    var icons = {
      safety_score: "warning",
      insurance: "verified_user",
      authority: "gavel",
      fraud: "report",
      oos: "block",
      asset_mismatch: "compare_arrows",
    };
    return icons[type] || "info";
  };

  var getSourceBadge = function (source) {
    var colors = {
      tsap: { bg: "#eef1f8", color: "#3E549D" },
      fmcsa: { bg: "#e6f7ee", color: "#27ae60" },
      internal: { bg: "#fff7e6", color: "#f39c12" },
    };
    var style = colors[source] || { bg: "#f0f0f0", color: "#666" };
    return (
      <span style={{
        padding: "2px 8px",
        borderRadius: "4px",
        fontSize: "11px",
        fontWeight: 600,
        backgroundColor: style.bg,
        color: style.color,
        textTransform: "uppercase",
      }}>
        {source || "system"}
      </span>
    );
  };

  var getStatusTag = function (status) {
    var colors = {
      new: "processing",
      acknowledged: "warning",
      resolved: "success",
    };
    return (
      <Tag color={colors[status] || "default"} style={{ textTransform: "capitalize" }}>
        {status || "New"}
      </Tag>
    );
  };

  var statCards = [
    { label: "Critical Alerts", value: stats.critical, color: "#e74c3c", bg: "#fde8e8" },
    { label: "High Alerts", value: stats.high, color: "#f39c12", bg: "#fff7e6" },
    { label: "Medium Alerts", value: stats.medium, color: "#f1c40f", bg: "#fffbe6" },
    { label: "Resolved Today", value: stats.resolved_today, color: "#27ae60", bg: "#e6f7ee" },
  ];

  return (
    <Layout2 title="Carrier Alerts" Sidetitle="Carrier Alerts">
      <div className="mainareas new-table-set">
        {/* Stats Row */}
        <div className="row mb-4">
          {statCards.map(function (card, idx) {
            return (
              <div className="col-md-3 col-sm-6 mb-3" key={idx}>
                <div
                  style={{
                    background: card.bg,
                    borderRadius: "8px",
                    padding: "20px",
                    borderLeft: "4px solid " + card.color,
                  }}
                >
                  <div style={{ fontSize: "13px", color: "#666", marginBottom: "4px" }}>
                    {card.label}
                  </div>
                  <div style={{ fontSize: "28px", fontWeight: 700, color: card.color }}>
                    {card.value}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Header */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
          <div className="bids-top mb-2 mb-sm-0">
            <h4>
              Alerts<span>{total}</span>
            </h4>
          </div>
        </div>

        {/* Filters */}
        <div className="d-flex flex-wrap gap-3 mb-3">
          <div>
            <select
              className="form-control"
              value={filters.severity}
              onChange={function (e) {
                var val = e.target.value;
                setFilter({ ...filters, severity: val, page: 1 });
                getData({ severity: val, page: 1 });
              }}
            >
              {severityOptions.map(function (opt) {
                return <option key={opt.value} value={opt.value}>{opt.label}</option>;
              })}
            </select>
          </div>
          <div>
            <select
              className="form-control"
              value={filters.type}
              onChange={function (e) {
                var val = e.target.value;
                setFilter({ ...filters, type: val, page: 1 });
                getData({ type: val, page: 1 });
              }}
            >
              {typeOptions.map(function (opt) {
                return <option key={opt.value} value={opt.value}>{opt.label}</option>;
              })}
            </select>
          </div>
          <div>
            <select
              className="form-control"
              value={filters.status}
              onChange={function (e) {
                var val = e.target.value;
                setFilter({ ...filters, status: val, page: 1 });
                getData({ status: val, page: 1 });
              }}
            >
              {statusOptions.map(function (opt) {
                return <option key={opt.value} value={opt.value}>{opt.label}</option>;
              })}
            </select>
          </div>
        </div>

        {/* Table */}
        <div className="table-responsive table_section new-table">
          <table className="table">
            <thead>
              <tr>
                <th scope="col" style={{ width: "30px" }}></th>
                <th scope="col">Severity</th>
                <th scope="col">Type</th>
                <th scope="col">Carrier</th>
                <th scope="col">Title</th>
                <th scope="col">Source</th>
                <th scope="col">Created</th>
                <th scope="col">Status</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {data?.map(function (itm, index) {
                var alertId = itm.id || itm._id;
                var isExpanded = expanded[alertId];
                return (
                  <React.Fragment key={alertId || index}>
                    <tr>
                      <td>
                        <span
                          style={{ cursor: "pointer", fontSize: "16px" }}
                          onClick={function () { toggleExpand(alertId); }}
                        >
                          {isExpanded ? <i className="fa fa-chevron-down"></i> : <i className="fa fa-chevron-right"></i>}
                        </span>
                      </td>
                      <td>{getSeverityTag(itm.severity)}</td>
                      <td>
                        <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                          <i className="material-icons" style={{ fontSize: "16px" }}>{getTypeIcon(itm.type || itm.alert_type)}</i>
                          <span style={{ textTransform: "capitalize", fontSize: "13px" }}>
                            {(itm.type || itm.alert_type || "").replace(/_/g, " ")}
                          </span>
                        </span>
                      </td>
                      <td>
                        <span
                          style={{ cursor: "pointer", color: "#3E549D", fontWeight: 500 }}
                          onClick={function () { historyHook.push("/carrier-dossier/" + (itm.carrier_id || itm.carrier)); }}
                        >
                          {itm.company_name || itm.carrier_name || "-"}
                        </span>
                      </td>
                      <td>{itm.title || "-"}</td>
                      <td>{getSourceBadge(itm.source)}</td>
                      <td style={{ fontSize: "12px" }}>{formatDate(itm.createdAt || itm.created_at)}</td>
                      <td>{getStatusTag(itm.status)}</td>
                      <td>
                        <div className="action_icons d-flex gap-1">
                          {itm.status === "new" && (
                            <Tooltip placement="top" title="Acknowledge">
                              <span
                                className="edit_icon pointer"
                                onClick={function () { handleAction(alertId, "acknowledge"); }}
                              >
                                <i className="material-icons pointer" style={{ fontSize: "18px" }}>check</i>
                              </span>
                            </Tooltip>
                          )}
                          {itm.status !== "resolved" && (
                            <Tooltip placement="top" title="Resolve">
                              <span
                                className="edit_icon pointer"
                                onClick={function () { handleAction(alertId, "resolve"); }}
                              >
                                <i className="material-icons pointer" style={{ fontSize: "18px" }}>done_all</i>
                              </span>
                            </Tooltip>
                          )}
                        </div>
                      </td>
                    </tr>
                    {isExpanded && (
                      <tr>
                        <td colSpan="9" style={{ background: "#f9f9f9", padding: "16px 24px" }}>
                          <div>
                            <strong>Description:</strong>
                            <p style={{ marginTop: "4px", fontSize: "13px", color: "#555" }}>
                              {itm.description || "No additional details available."}
                            </p>
                          </div>
                          {itm.source_data && (
                            <div style={{ marginTop: "8px" }}>
                              <strong>Source Data:</strong>
                              <pre style={{ fontSize: "12px", background: "#fff", padding: "8px", borderRadius: "4px", marginTop: "4px", maxHeight: "200px", overflow: "auto" }}>
                                {typeof itm.source_data === "string" ? itm.source_data : JSON.stringify(itm.source_data, null, 2)}
                              </pre>
                            </div>
                          )}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Empty State */}
        {total === 0 && !loaderr ? (
          <div className="no-data">
            <img src="assets/img/no-data.png" alt="No data" />
            No Alerts Found
          </div>
        ) : null}

        {/* Pagination */}
        {total > 0 ? (
          <div className="paginationWrapper gap-0">
            <div className="d-flex align-items-center mb-2 mb-sm-0">
              <div className="me-2 user-name-color">Show</div>
              {total > 0 && (
                <div className="dropdown addDropdown chnagesname">
                  <button
                    className="btn btn-primary dropdown-toggle removeBg"
                    type="button"
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {filters?.count}
                  </button>
                  <div
                    className="dropdown-menu shadow bg_hover"
                    aria-labelledby="dropdownMenuButton"
                  >
                    {[10, 20, 30, 50].map(function (n) {
                      return (
                        <a
                          key={n}
                          className="dropdown-item"
                          onClick={function () { ChangeFilter({ ...filters, count: n, page: 1 }); }}
                        >
                          {n}
                        </a>
                      );
                    })}
                  </div>
                </div>
              )}
              <div className="ms-2 user-name-color">
                from {total} Alerts
              </div>
            </div>
            <Pagination
              currentPage={filters.page}
              totalSize={total}
              sizePerPage={filters.count}
              changeCurrentPage={pageChange}
            />
          </div>
        ) : null}
      </div>
    </Layout2>
  );
};

export default CarrierAlerts;
